// INIT CALLBACK SCOPE

$(() => {
  new LazyLoad({
    use_native: true,
  });

  setContactListener();

  anime({
    targets: ".onload-animate-in",
    opacity: ["0%", "100%"],
    translateY: ["-10px", "0"],
    easing: "easeInOutQuad",
    duration: 600,
    delay: anime.stagger(200, { start: 100 }),
  });
});
